const assets = import.meta.glob<string>(
  '../assets/**/*.{png,jpg,jpeg,svg,webp,gif,avif,ico}',
  { eager: true, query: '?url', import: 'default' }
);

export function getAsset(src?: string): string | undefined {
  if (!src) {
    console.warn('Asset not found: empty src');
    return undefined;
  }

  const asset = assets[`../assets/${src}`];
  if (!asset) {
    console.warn(`Asset not found: ${src}`);
    return undefined;
  }

  return asset;
}